"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../basics/Button"));
var Lockup_1 = __importDefault(require("../../basics/Lockup"));
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var typography_1 = require("../../typography");
var PageSection_1 = __importDefault(require("../../basics/PageSection"));
var styles_1 = require("./styles");
var LibraryPostInterviewBlock = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'Interview' : _b, quote = _a.quote, description = _a.description, href = _a.href, _c = _a.buttonText, buttonText = _c === void 0 ? 'Read the interview' : _c, commonProps = __rest(_a, ["type", "quote", "description", "href", "buttonText"]);
    return (react_1.default.createElement(PageSection_1.default, __assign({ "data-component-name": "LibraryPostInterviewBlock" }, commonProps, { backgroundColor: "pale-blue", collapseBottomPadding: true, collapseTopPadding: true }),
        react_1.default.createElement(styles_1.Wrapper, null,
            react_1.default.createElement(TextVerticalSpacer_1.default, { level: "3" },
                type && (react_1.default.createElement(typography_1.Label, { level: "1", color: "GREY_70" }, type)),
                react_1.default.createElement(Lockup_1.default, { title: "\"".concat(quote, "\""), titleMaxWidth: 24, level: "3", subtitle: description, subtitleMaxWidth: 32, titleColor: "GREY_90" })),
            react_1.default.createElement(Button_1.default, { href: href, version: "outline" }, buttonText))));
};
exports.default = LibraryPostInterviewBlock;
